import { render, staticRenderFns } from "./listmodelli.vue?vue&type=template&id=4a9b79ec&scoped=true&"
import script from "./listmodelli.vue?vue&type=script&lang=js&"
export * from "./listmodelli.vue?vue&type=script&lang=js&"
import style0 from "./listmodelli.vue?vue&type=style&index=0&id=4a9b79ec&prod&scoped=true&lang=css&"
import style1 from "./listmodelli.vue?vue&type=style&index=1&id=4a9b79ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b79ec",
  null
  
)

export default component.exports